export const HOME = "/";
export const PRODUCTS = "/products";
export const CART = "/cart";
export const MENU = "/menu";
export const CHECKOUT = "/checkout";
export const SUCCESS = "/success";
